export const B2X_ACTIVE_PROFILE_CONNECTION_NAME = 'B2X_ACTIVE_PROFILE';
